import gql from 'graphql-tag';

export default gql`
subscription ($organizationId: String!) {
  withdrawalUpdate (organizationId: $organizationId,) {
    id
    tx
    status
  }
}
`